import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Link, useHistory } from "react-router-dom";
import "./Login.css";
import credencial from "../img/img1.jpg";
import CryptoJS from "crypto-js";
import { API_BASE } from "../config";
import { guardarSesion } from "../utilities/sesion";

const Login = ({ alumno, modificarAlumno, cambiarLogin, cambiarDatosPago, esCajero, setEsCajero }) => {
  const [error, guardarError] = useState(false);
  const [modal, verModal] = useState(false);
  const [modal2, verModal2] = useState(false);
  const [mensajeError, cambiarMensajeError] = useState("");
  const [datosCajero, setDatosCajero] = useState({ usuario: "", password: "" });
  const history = useHistory();

  useEffect(() => {
    cambiarDatosPago({
      referencia: "",
      importe: "",
      key: "",
    });
  }, [cambiarDatosPago]);

  // --- LÓGICA ALUMNOS (Sin cambios) ---
  const HandleSubmitAlumno = (e) => {
    e.preventDefault();
    if (alumno.codigo.trim().length !== 14) {
      cambiarMensajeError("El código debe tener 14 caracteres");
      guardarError(true);
      return;
    }
    guardarError(false);
    let formData = new FormData();
    formData.append("matricula", alumno.codigo.trim());
    formData.append("cod", CryptoJS.SHA256("pcecytej-".concat(alumno.codigo.trim(), "-pcecytej")));
    const fun = async () => {
      try {
        const res = await fetch(`${API_BASE}/wMultipagos.php`, { body: formData, method: "POST" });
        const resp = await res.json();
        if (resp && resp[0] && resp[0].rupid !== '') {
          const nombreCompleto = `${resp[0].nombres} ${resp[0].apellido_paterno} ${resp[0].apellido_materno}`;
          modificarAlumno({ ...alumno, nombre: nombreCompleto, matricula: resp[0].matricula, grado: resp[0].grado, grupo: resp[0].grupo, turno: resp[0].turno, plantel_id: resp[0].plantel_id });
          verModal2(true);
        } else {
          cambiarMensajeError("Alumno no encontrado en la base de datos");
          guardarError(true);
        }
      } catch (error) {
        cambiarMensajeError("Error de conexión con el servidor");
        guardarError(true);
      }
    };
    fun();
  };

  const HandleChangeAlumno = (e) => {
    modificarAlumno({ ...alumno, [e.target.name]: e.target.value.trim() });
  };

  // --- LÓGICA CAJEROS (Sin cambios) ---
  const HandleChangeCajero = (e) => {
    setDatosCajero({ ...datosCajero, [e.target.name]: e.target.value.trim() });
  };

  const HandleSubmitCajero = async (e) => {
    e.preventDefault();
    if (datosCajero.usuario === "" || datosCajero.password === "") {
      cambiarMensajeError("Todos los campos son obligatorios");
      guardarError(true);
      return;
    }
    guardarError(false);
    try {
      const res = await fetch(`${API_BASE}/wMultipagosLogin.php`, { 
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ usuario: datosCajero.usuario, password: datosCajero.password })
      });
      const resp = await res.json();
      if (resp.success) {
        localStorage.setItem("cajero_id", resp.id_usuario);
        localStorage.setItem("cajero_plantel", resp.id_plantel);
        localStorage.setItem("cajero_rol", resp.id_rol);
        localStorage.setItem("cajero_nombre", resp.nombre_cajero);
        localStorage.setItem("cajero_nombre_plantel", resp.nombre_plantel);
        guardarSesion(resp.token);
        history.push("/dashboard-cajero");
      } else {
        cambiarMensajeError(resp.mensaje || "Credenciales incorrectas");
        guardarError(true);
      }
    } catch (error) {
      console.error("Error API Cajero:", error);
      cambiarMensajeError("Error de conexión con el servidor");
      guardarError(true);
    }
  };

  return (
  <div className="Login-main-container">
    <div className="Login-form-card">
      
      {/* Encabezado dinámico: Cambia según el módulo */}
      <div className="Login-header">
        <h1>CECyTE Jalisco</h1>
        <h2>
          {!esCajero 
            ? "Ingreso Alumnos" 
            : "Sistema Integral de Recaudación"}
        </h2>
      </div>

      {/* --- FORMULARIO ALUMNOS --- */}
      {!esCajero ? (
        <div className="form-fade-in">
          <form onSubmit={HandleSubmitAlumno} className="Login-active-form">
            <div className="input-group">
              <label htmlFor="codigo">Introduce tu número de matrícula</label>
              <input
                id="codigo"
                type="text"
                name="codigo"
                placeholder="Ej: 20210001001234"
                onChange={HandleChangeAlumno}
                value={alumno.codigo || ""}
                required
              />
            </div>
            {error && !esCajero && <p className="error-message">{mensajeError}</p>}
            <button className="Login-action-button button-alumno" type="submit">
              Verificar Datos
            </button>
          </form>
          
          <div className="Login-extra-links">
            ¿No sabes tu código? Consúltalo en tu{" "}
            <button onClick={() => verModal(true)} className="link-as-button">
              credencial
            </button>
          </div>
        </div>
      ) : (
        /* --- FORMULARIO CAJEROS --- */
        <div className="form-fade-in">
          <form onSubmit={HandleSubmitCajero} className="Login-active-form">
            <div className="input-group">
              <label htmlFor="usuario">Usuario</label>
              <input
                id="usuario"
                type="text"
                name="usuario"
                placeholder="@cecytejalisco.edu.mx"
                onChange={HandleChangeCajero}
                value={datosCajero.usuario || ""}
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="password">Contraseña</label>
              <input
                id="password"
                type="password"
                name="password"
                placeholder="*******"
                onChange={HandleChangeCajero}
                value={datosCajero.password || ""}
                required
              />
            </div>
            {error && esCajero && <p className="error-message">{mensajeError}</p>}
            <button className="Login-action-button button-cajero" type="submit">
              Iniciar Sesión
            </button>
          </form>

          {/* RUTA DE ESCAPE PARA EL ALUMNO */}
          <div className="Login-extra-links">
            ¿Eres estudiante?{" "}
            <button onClick={() => setEsCajero(false)} className="link-as-button">
              Regresar al Módulo Alumno
            </button>
          </div>
        </div>
      )}
    </div>

      {/* --- MODALES --- */}
      
      {/* 1. Modal de la Credencial */}
      <Modal 
        className="Login-modal" 
        overlayClassName="Login-modal-overlay" /* AQUÍ CONECTAMOS EL FONDO OSCURO */
        isOpen={modal} 
        ariaHideApp={false} 
        onRequestClose={() => verModal(false)} 
        style={{content: { border:'none', background:'none', padding:0, outline: 'none' }}}
      >
        <img 
          className="Login-img-modal" 
          src={credencial} 
          alt="credencial" 
          style={{maxHeight: '80vh', maxWidth: '100%', objectFit: 'contain'}} 
        />
      </Modal>

      {/* 2. Modal de Verificación de Alumno */}
      <Modal 
        className="Login-modal-pregunta" 
        overlayClassName="Login-modal-overlay" /* AQUÍ CONECTAMOS EL FONDO OSCURO */
        isOpen={modal2} 
        ariaHideApp={false} 
        onRequestClose={() => verModal2(false)}
      >
        <div className="modal-content">
          <h2>Verificación de Identidad</h2>
          <p>¿Eres <span className="student-name">{alumno.nombre}</span>?</p>
          <p style={{
            fontSize: '0.85rem', color: '#7a5c00', backgroundColor: '#fff3cd',
            border: '1px solid #ffe082', borderRadius: '6px', padding: '10px 12px',
            margin: '4px 0 12px', textAlign: 'left'
          }}>
            ⚠️ Las referencias que generes o pagues aquí quedan registradas a nombre de <strong>{alumno.nombre}</strong>. No uses la matrícula de alguien más: cada alumno debe ingresar con su propia matrícula.
          </p>
          <div className="modal-actions">
            <Link className="modal-button accept" onClick={() => cambiarLogin(true)} to="/tipo">Sí, soy yo</Link>
            <button className="modal-button decline" onClick={() => verModal2(false)}>No, corregir</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Login;